module.exports = __webpack_public_path__ + "img/Inaceval.938e3a3d.svg";